import React from "react";
import { Button, Notification } from "@flixbus/honeycomb-react";
import styles from "./StaleVersionBanner.module.scss";

interface StaleVersionBannerProps {
  onReload: () => void;
  onDismiss: () => void;
}

const StaleVersionBanner: React.FC<StaleVersionBannerProps> = ({
  onReload,
  onDismiss,
}) => (
  <Notification
    appearance="warning"
    extraClasses={styles.banner}
    closeProps={{ onClick: onDismiss, "aria-label": "Dismiss" }}
  >
    {
      "This calculation was updated by someone else. Reload to see the latest values; your unsaved changes will be discarded."
    }{" "}
    <Button appearance="primary" onClick={onReload}>
      Reload
    </Button>
  </Notification>
);

export default StaleVersionBanner;
